import {
    Banner,
    BannerDescription,
    BannerEyebrow,
    BannerLinks,
    BannerText,
    BannerTextContainer,
    BannerTitle,
    Box,
    Button,
    FlexBox,
    FluidImage,
    H1,
    P,
} from '@vp/swan';
import styled from 'styled-components';
import { __, __image } from '@99designs/i18n';
import { CloudinaryImage } from '../CloudinaryImage';
import { HeaderPrice } from '../HeaderPrice';
import { useProductPricingContext } from '../ProductPricingContext';

interface HeaderProps {
    browseDesignServicesCtaOnClick: () => void;
    howItWorksCtaOnClick: () => void;
}

const ImageContainer = styled(FlexBox)`
    flex-basis: 50%;
`;

export function Header({ browseDesignServicesCtaOnClick, howItWorksCtaOnClick }: HeaderProps) {
    const { lowestPrice, priceLoading } = useProductPricingContext();

    return (
        <Banner backgroundColor="accent" data-testid="hero">
            <BannerTextContainer>
                <BannerText>
                    <BannerEyebrow>{__('Design Services')}</BannerEyebrow>
                    <BannerTitle as={H1} fontSkin="title-headline">
                        {__('You take care of your business, we’ll take care of the design')}
                    </BannerTitle>
                    <BannerDescription>
                        <P>
                            {__(
                                'Work with professional, talented designers to bring your brand to life – from handcrafted logos to custom marketing materials and beyond.'
                            )}
                        </P>
                    </BannerDescription>
                    <Box fontSkin="title-item">
                        <HeaderPrice price={lowestPrice} loading={priceLoading} />
                    </Box>
                    <BannerLinks>
                        <Button skin="primary" onClick={browseDesignServicesCtaOnClick}>
                            {__('Browse design services')}
                        </Button>
                        <Button skin="secondary" onClick={howItWorksCtaOnClick}>
                            {__('How it works')}
                        </Button>
                    </BannerLinks>
                </BannerText>
            </BannerTextContainer>
            <ImageContainer flexDirection="column" justifyContent="center" alignItems="flex-start">
                <CloudinaryImage
                    render={(props) => (
                        <FluidImage
                            src={props.src}
                            srcSet={props.srcSet}
                            alt=""
                            role="presentation"
                        />
                    )}
                    imagePath={__image('expert_services/HubPage/hero-image')}
                    width={686}
                />
            </ImageContainer>
        </Banner>
    );
}
